import { OdataFieldBasicOperator } from './OdataFieldBasicOperator';
import { IOdataField } from '../../IOdataField';

export class OdataFieldMonth extends OdataFieldBasicOperator {
  constructor(field: IOdataField) {
    super(field, 'month');
  }
}
